'use strict';

exports.__esModule = true;

var _processAdv = require('handlebars-loader!templates/processAdv.html');

var _processAdv2 = _interopRequireDefault(_processAdv);

var _underscore = require('utils/underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _helpers = require('utils/helpers');

var _helpers2 = _interopRequireDefault(_helpers);

var _css = require('utils/css');

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * @file 播放器广告类
                                                                                                                                                           * @author zhangzhe(zhangzhe@baidu.com)
                                                                                                                                                           */

var AdvManager = function () {
    function AdvManager(imageAdvs) {
        _classCallCheck(this, AdvManager);

        this.api = null;
        // 播放过程中广告
        if (imageAdvs && imageAdvs.advs && _underscore2['default'].isArray(imageAdvs.advs) && imageAdvs.advs.length) {
            this.processAdvs = imageAdvs.advs;
            this.hasProcessAdv = true;
            this.el = _helpers2['default'].createElement((0, _processAdv2['default'])());
        } else {
            this.hasProcessAdv = false;
        }
        this.activeAdv = null; // 当前正在播放的广告
    }

    AdvManager.prototype.setApi = function setApi(api) {
        this.api = api;
    };

    AdvManager.prototype.refreshProcessAdv = function refreshProcessAdv(currentTime) {
        var processAdv = _underscore2['default'].find(this.processAdvs, function (processAdv) {
            return currentTime >= processAdv.begin && currentTime <= processAdv.end;
        });

        if (processAdv) {
            if (processAdv !== this.activeAdv) {
                this.showAdv(processAdv);
                this.activeAdv = processAdv;
            }
        } else {
            // 需要隐藏所有广告
            this.hideAllProcessAdvs();
        }
    };

    AdvManager.prototype.showAdv = function showAdv(processAdv) {
        var linkDom = this.element().getElementsByTagName('a')[0];
        var imgDom = linkDom.getElementsByTagName('img')[0];
        // href
        linkDom.setAttribute('href', processAdv.material.landingPage);
        // 图片地址
        imgDom.setAttribute('src', processAdv.material.image);

        var advStyle = {
            'display': 'block',
            'z-index': 500,
            'opacity': 0.9,
            'left': 'auto',
            'right': 'auto',
            'top': 'auto',
            'bottom': 'auto'
        };

        // 水平位置
        if (processAdv.material.horizontalPosition === 'left') {
            advStyle.left = 10;
        } else {
            advStyle.right = 10;
        }

        // 垂直位置
        if (processAdv.material.verticalPosition === 'top') {
            advStyle.top = 10;
        } else {
            advStyle.bottom = 50;
        }

        _css2['default'].style(this.element(), advStyle);
    };

    AdvManager.prototype.hideAllProcessAdvs = function hideAllProcessAdvs() {
        // 隐藏广告
        this.element().style.display = 'none';
        this.activeAdv = null;
    };

    AdvManager.prototype.element = function element() {
        if (this.api) {
            var container = this.api.getContainer();
            if (_helpers2['default'].getElementsByClassName('jw-process-adv', container).length > 0) {
                return _helpers2['default'].getElementsByClassName('jw-process-adv', container)[0];
            }
        }
        return this.el;
    };

    return AdvManager;
}();

exports['default'] = AdvManager;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/baidu/adv-manage.js
 ** module id = 149
 ** module chunks = 0
 **/